export function randomId(): string {
  return crypto.randomUUID();
}

/**
 * Deterministic id derived from a node's path. Two devices importing the
 * same bookmark at the same place produce the same id, so simultaneous
 * first-time imports merge on the server instead of duplicating.
 */
export async function deterministicId(seed: string): Promise<string> {
  const digest = new Uint8Array(await crypto.subtle.digest('SHA-256', new TextEncoder().encode(seed)));
  const b = digest.slice(0, 16);
  b[6] = (b[6]! & 0x0f) | 0x50; // version 5-style
  b[8] = (b[8]! & 0x3f) | 0x80; // RFC 4122 variant
  const hex = [...b].map((x) => x.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
